import { render, staticRenderFns } from "./UniformCheckboxSelect.vue?vue&type=template&id=2905f8a2"
import script from "./UniformCheckboxSelect.vue?vue&type=script&lang=js"
export * from "./UniformCheckboxSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports